module.exports = __webpack_public_path__ + "static/media/admin.c19eaedd.png";